import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ResponsiveService } from 'src/app/shared/responsive/responsive.service';
import { environment as ENV } from './../environments/environment.development';
import * as constant from './../app/shared/constants/constants';
import { StorageService } from './shared/services/storage.service';
import { localStorageKeys, translate_enum } from './core/enum';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(public responsiveService:ResponsiveService , public translate : TranslateService, public storageService: StorageService) {
    this.getTranslationFile()
  }

  async getTranslationFile(){
        if(await this.storageService.get(localStorageKeys.market)){
          this.translate.use(translate_enum[await this.storageService.get(localStorageKeys.market)])
        }
        else{
          this.translate.use('common')
        }
  }
  title = 'costa-coffee-ui';
}
